import React from 'react';

import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions';

import { Attribution, ErrorBoundary } from '@confluence/error-boundary';
import { usePageContentId } from '@confluence/page-context';

import { NBMRenderer } from './NBMRenderer';
import type { LegacyContentMacroParams } from './LegacyContentMacroParams';

export const LegacyContentExtensionHandler = (
	props: ExtensionComponentProps<LegacyContentMacroParams>,
) => {
	const [contentId] = usePageContentId();

	return (
		<ErrorBoundary
			attribution={Attribution.CC_EDITOR_AI}
			attributes={{ contentId, nodeLocalId: props.node?.localId }}
		>
			<NBMRenderer node={props.node} />
		</ErrorBoundary>
	);
};
